import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { supabase } from '../lib/supabase'

export default function ResetPassword() {
  const [password, setPassword]   = useState('')
  const [confirm, setConfirm]     = useState('')
  const [loading, setLoading]     = useState(false)
  const [error, setError]         = useState(null)
  const [success, setSuccess]     = useState(false)
  const [validLink, setValidLink] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    // Supabase puts the token in the URL hash when user clicks email link
    const hash = window.location.hash
    if (hash && hash.includes('access_token')) {
      setValidLink(true)
    } else {
      // Check if we have an active session from the email link
      supabase.auth.getSession().then(({ data: { session } }) => {
        if (session) setValidLink(true)
      })
    }
  }, [])

  async function handleSubmit(e) {
    e.preventDefault()
    if (password !== confirm) {
      setError('Passwords do not match.')
      return
    }
    if (password.length < 8) {
      setError('Password must be at least 8 characters.')
      return
    }
    setLoading(true)
    setError(null)

    const { error } = await supabase.auth.updateUser({ password })
    setLoading(false)

    if (error) {
      setError(error.message)
    } else {
      setSuccess(true)
      setTimeout(() => navigate('/login'), 3000)
    }
  }

  return (
    <div style={{
      minHeight: '100vh',
      background: '#F7F2EB',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: "'Montserrat', sans-serif",
      padding: '2rem',
    }}>
      <div style={{
        background: '#fff',
        border: '1px solid #EDE6DA',
        borderRadius: 12,
        padding: '2.5rem',
        width: '100%',
        maxWidth: 420,
      }}>
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
          <div style={{
            width: 52, height: 52, borderRadius: '50%',
            border: '2px solid #B8734A',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            margin: '0 auto 1rem',
            background: 'rgba(184,115,74,0.08)',
          }}>
            <svg width="22" height="22" viewBox="0 0 22 22" fill="none">
              <rect x="3" y="10" width="16" height="11" rx="2" stroke="#B8734A" strokeWidth="1.5"/>
              <path d="M7 10V7a4 4 0 0 1 8 0v3" stroke="#B8734A" strokeWidth="1.5" strokeLinecap="round"/>
            </svg>
          </div>
          <h1 style={{
            fontFamily: 'Georgia, serif',
            fontSize: '1.4rem',
            color: '#2B2B2B',
            fontWeight: 600,
            marginBottom: 4,
          }}>Set New Password</h1>
          <p style={{ fontSize: 12, color: '#6B7D6B' }}>
            Collective Staff · collectivestaff.app
          </p>
        </div>

        {success ? (
          <div style={{
            background: 'rgba(74,124,89,0.1)',
            border: '1px solid #4A7C59',
            borderRadius: 8,
            padding: '1.25rem',
            textAlign: 'center',
          }}>
            <div style={{ fontSize: 28, marginBottom: 8 }}>✓</div>
            <div style={{ fontSize: 14, fontWeight: 600, color: '#4A7C59', marginBottom: 4 }}>
              Password updated!
            </div>
            <div style={{ fontSize: 12, color: '#6B7D6B' }}>
              Redirecting you to login in a moment...
            </div>
          </div>
        ) : !validLink ? (
          <div style={{
            background: 'rgba(160,57,43,0.08)',
            border: '1px solid #A0392B',
            borderRadius: 8,
            padding: '1.25rem',
            textAlign: 'center',
          }}>
            <div style={{ fontSize: 13, color: '#A0392B', fontWeight: 500, marginBottom: 8 }}>
              This link has expired or is invalid.
            </div>
            <button
              onClick={() => navigate('/login')}
              style={{
                padding: '8px 20px', background: '#B8734A', border: 'none',
                borderRadius: 6, color: '#fff', fontSize: 12, fontWeight: 600,
                cursor: 'pointer', fontFamily: "'Montserrat', sans-serif",
              }}>
              Back to Login
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: 14 }}>
              <label style={{
                display: 'block', fontSize: 10, textTransform: 'uppercase',
                letterSpacing: '0.1em', color: '#6B7D6B', fontWeight: 600, marginBottom: 5,
              }}>New Password</label>
              <input
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                placeholder="At least 8 characters"
                required
                style={{
                  width: '100%', padding: '10px 13px',
                  border: '1px solid #EDE6DA', borderRadius: 6,
                  fontSize: 13, fontFamily: "'Montserrat', sans-serif",
                  outline: 'none', color: '#2B2B2B',
                }}
              />
            </div>

            <div style={{ marginBottom: 14 }}>
              <label style={{
                display: 'block', fontSize: 10, textTransform: 'uppercase',
                letterSpacing: '0.1em', color: '#6B7D6B', fontWeight: 600, marginBottom: 5,
              }}>Confirm Password</label>
              <input
                type="password"
                value={confirm}
                onChange={e => setConfirm(e.target.value)}
                placeholder="Re-enter your password"
                required
                style={{
                  width: '100%', padding: '10px 13px',
                  border: `1px solid ${confirm && confirm !== password ? '#A0392B' : '#EDE6DA'}`,
                  borderRadius: 6, fontSize: 13,
                  fontFamily: "'Montserrat', sans-serif",
                  outline: 'none', color: '#2B2B2B',
                }}
              />
              {confirm && confirm !== password && (
                <div style={{ fontSize: 11, color: '#A0392B', marginTop: 4 }}>
                  Passwords do not match
                </div>
              )}
            </div>

            {error && (
              <div style={{
                background: 'rgba(160,57,43,0.08)', border: '1px solid #A0392B',
                borderRadius: 6, padding: '8px 12px',
                fontSize: 12, color: '#A0392B', marginBottom: 14,
              }}>
                {error}
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              style={{
                width: '100%', padding: '11px',
                background: loading ? '#8A9E8A' : '#B8734A',
                border: 'none', borderRadius: 6, color: '#fff',
                fontFamily: "'Montserrat', sans-serif",
                fontSize: 13, fontWeight: 600, cursor: loading ? 'default' : 'pointer',
                letterSpacing: '0.05em',
              }}>
              {loading ? 'Updating...' : 'Set New Password →'}
            </button>

            <div style={{ textAlign: 'center', marginTop: 14 }}>
              <span
                onClick={() => navigate('/login')}
                style={{ fontSize: 11, color: '#B8734A', cursor: 'pointer', fontWeight: 500 }}>
                ← Back to login
              </span>
            </div>
          </form>
        )}

        <div style={{
          marginTop: '1.5rem', paddingTop: '1rem',
          borderTop: '1px solid #EDE6DA',
          textAlign: 'center', fontSize: 10, color: 'rgba(107,125,107,0.5)',
        }}>
          Powered by <span style={{ color: '#B8734A' }}>Collective Staff</span> · A GCW Product
        </div>
      </div>
    </div>
  )
}